import { useQuery } from '@tanstack/react-query'
import { loadOrderIndex, type OrderIndex } from '@/lib/cross-context'
import { keys } from '@/lib/query'

/** The cross-context flag index (issue id → where it's near the top elsewhere),
 *  read once and shared by every flag on screen. Same read-after-write caveat as
 *  the per-context order, so focus refetch is off. */
export function useCrossContextIndex() {
  return useQuery<OrderIndex>({
    queryKey: keys.crossContextIndex,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: loadOrderIndex,
  })
}
